<div *ngIf="sproutFormDataService.instance || model">
  <form-viewer [model]="model"></form-viewer>
</div>
